import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import { TweenMax } from 'gsap';
import EFVideo from '@/components/UI/EFVideo';

export default function CSection() {
    const { useEffect, useLang } = useGlobal()
    const { t } = useLang('xboost')

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        const scene1 = new ScrollMagic.Scene({
            triggerElement: '.C_section .textBox .title',
            offset: 200,
            triggerHook: 1,
            duration: 200,
        })
            .setTween(TweenMax.to('.C_section .textBox .title', 0.5, { opacity: 1 }))
            .addTo(controller);

        const scene2 = new ScrollMagic.Scene({
            triggerElement: '.C_section .textBox .text',
            offset: 100,
            triggerHook: 1,
            duration: 200,
        })
            .setTween(TweenMax.to('.C_section .textBox .text', 0.5, { opacity: 1 }))
            .addTo(controller);
    }, []);

    return (
        <div className={`C_section ${css.C_section}`}>
            <div className="videoBox">
                <div className="textBox">
                    <p className="title">{t('section_3_title')}</p>
                    <p className="text">{t('section_3_desc')}</p>
                </div>
                <div className="video-box-right">
                    <EFVideo sources={["/video/xboost/03_fast.webm", "/video/xboost/03_fast.mp4"]} className="video" width={'100%'} height={'100%'} playsInline autoPlay loop muted preload="auto" />
                </div>
            </div>
        </div>
    );
}
